import { useMutation } from '@tanstack/react-query';
import { updateStoreSettings } from '@/lib/api/settings';
import { queryClient } from '@/queries';
import { useUser } from '@/queries/useUser';
import { QUERY_KEYS } from '@/lib/constants';

export const useStoreSettings = () => {
    const { user } = useUser();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: Record<string, any>) => {
            // Always include the current currency to prevent it from being reset to USD
            // This matches Vue behavior where all settings are sent together
            const payload = {
                currency: user?.data?.currency?.toUpperCase() || 'USD',
                ...data,
            };
            return updateStoreSettings(payload);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
